import React, { Component } from 'react';
import moment from "moment";
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import Request from "../../core/httpClient";
import UnifiedDatePicker from '../../components/Calendario';

const request = new Request();

class PropietarioEditarModal extends Component {
	constructor(props) {

		super(props);
		this.state = {
			idPersona: 0,
			pNombre: '',
			IDireccion: '',
			IMunicipio: '',
			IEstado: '',
			ICp: '',
			pTelefono: '',
			IPais: '',
			IGenero: 0,
			IId: '',
			INumId: '',
			IVigencia: '',
			IFechaIngreso: '',
			code: '',
			Iviv: '',
			IIdViv: 0,
			email: '',
			pFechaVenta: '',
			citye: '',
			comentarios: '',
			es_residente: ''
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state !== prevState) {
			this.props.setInfo(this.state);
		}
		if (this.props.telefonoError !== prevProps.telefonoError) {
			this.setState({ telefonoError: this.props.telefonoError });
		}

		if (this.props.propietario !== prevProps.propietario) {
			let phone = '';
			const { telefono } = this.props.propietario;
			if (telefono) {
				phone = parsePhoneNumber(`+${telefono}`);
				if (phone) {
					phone = phone.number;
				}
			}
			this.setState({
				pIdPersona: this.props.propietario.id_persona,
				pNombre: this.props.propietario.nombre,
				pDireccion: this.props.propietario.direccion,
				pMunicipio: this.props.propietario.municipio,
				pEstado: this.props.propietario.estado,
				pCp: this.props.propietario.cp,
				pTelefono: phone,
				pPais: this.props.propietario.pais,
				pGenero: this.props.propietario.genero,
				pId: this.props.propietario.tipo_identificacion,
				pNumId: this.props.propietario.num_identificacion,
				pVigencia: this.props.propietario.vigencia_identificacion,
				pFechaCompra: this.props.propietario.fecha_compra && moment(this.props.propietario.fecha_compra).isValid()
					? moment(this.props.propietario.fecha_compra).format("YYYY-MM-DD")
					: '',
				pFechaVenta: this.props.propietario.fecha_venta && moment(this.props.propietario.fecha_venta).isValid()
					? moment(this.props.propietario.fecha_venta).format("YYYY-MM-DD")
					: '',
				code: this.props.propietario.code,
				Iviv: this.props.propietario.numero_registro,
				pIdViv: this.props.propietario.id_vivienda,
				email: this.props.propietario.email,
				citye: this.props.propietario.ciudad || '',
				comentarios: this.props.propietario.comentarios || '',
				es_residente: this.props.propietario.es_residente || ''
			});
		}
	}

	render() {
		// Convertir strings YYYY-MM-DD a Date con validación
		const fechaCompraObj = this.state.pFechaCompra && moment(this.state.pFechaCompra, 'YYYY-MM-DD', true).isValid()
			? moment(this.state.pFechaCompra, 'YYYY-MM-DD', true).toDate()
			: null;

		const fechaVentaObj = this.state.pFechaVenta && moment(this.state.pFechaVenta, 'YYYY-MM-DD', true).isValid()
			? moment(this.state.pFechaVenta, 'YYYY-MM-DD', true).toDate()
			: null;

		return (
			<div className="tw-full tw-row tw-align-center">
				<div className="column full">
					<div className="tw-flex tw-flex-col tw-space-y-2 tw-w-full">
						{/* Subfraccionamiento */}
						<div className="tw-flex tw-items-center tw-gap-2">
							<label className="tw-w-32 tw-text-sm tw-font-semibold">{this.props.subLabel}:</label>
							<input
								type="text"
								name="subfraccionamiento"
								disabled
								value={this.props.subname}
								className="tw-flex-1 tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm"
								placeholder="Subfraccionamiento"
							/>
						</div>

						{/* Unidad */}
						<div className="tw-flex tw-items-center tw-gap-2">
							<label className="tw-w-32 tw-text-sm tw-font-semibold">Unidad:</label>
							<input
								type="text"
								name="vivienda"
								disabled
								value={this.state.Iviv}
								onChange={e => this.setState(prev => ({ ...prev, Iviv: e.target.value }))}
								className="tw-flex-1 tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm"
								placeholder="N° de vivienda"
								required
								maxLength="64"
							/>
						</div>

						{/* Teléfono */}
						<div className="tw-flex tw-items-center tw-gap-2">
							<label className="tw-w-32 tw-text-sm tw-font-semibold">
								Teléfono:<span className="tw-text-red-500">*</span>
							</label>
							<PhoneInput
								displayInitialValueAsLocalNumber
								name="phoneNumber"
								defaultCountry="MX"
								maxLength="18"
								placeholder="Número de teléfono"
								value={this.state.pTelefono}
								disabled
								onChange={value =>
									this.setState(prev => ({ ...prev, pTelefono: value, telefonoError: undefined }))
								}
								error={this.state.telefonoError}
								readOnly
								className="tw-flex-1 tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm"
							/>
						</div>

						{/* Nombre completo */}
						<div className="tw-flex tw-items-center tw-gap-2">
							<label className="tw-w-32 tw-text-sm tw-font-semibold">
								Nombre completo:<span className="tw-text-red-500">*</span>
							</label>
							<input
								type="text"
								name="fullName"
								value={this.state.pNombre}
								id="editownername"
								onChange={e => this.setState(prev => ({ ...prev, pNombre: e.target.value }))}
								className="tw-flex-1 tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm"
								placeholder="Nombre completo del propietario"
								required
								maxLength="64"
								disabled
							/>
						</div>

						<div className="tw-flex tw-flex-col tw-space-y-2 tw-w-full">
							{/* Género y Correo */}
							<div className="tw-grid tw-grid-cols-2 tw-gap-2">
								<div className="tw-flex tw-flex-col tw-space-y-1">
									<label className="tw-text-sm tw-font-semibold">Género:</label>
									<select
										name="sex"
										value={this.state.pGenero}
										onChange={e => this.setState(prev => ({ ...prev, pGenero: e.target.value }))}
										className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
										required
									>
										<option value="0">Hombre</option>
										<option value="1">Mujer</option>
										<option value="2">No especificado</option>
									</select>
								</div>
								<div className="tw-flex tw-flex-col tw-space-y-1">
									<label className="tw-text-sm tw-font-semibold">Correo:</label>
									<input
										type="email"
										name="email"
										value={this.state.email}
										onChange={e => this.setState(prev => ({ ...prev, email: e.target.value }))}
										className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
										placeholder="Email"
										maxLength="64"
									/>
								</div>
							</div>

							{/* Identificación e ID */}
							<div className="tw-grid tw-grid-cols-2 tw-gap-2">
								<div className="tw-flex tw-flex-col tw-space-y-1">
									<label className="tw-text-sm tw-font-semibold">Identificación:</label>
									<select
										name="id"
										id="idEddit"
										value={this.state.pId}
										onChange={e => this.setState(prev => ({ ...prev, pId: e.target.value }))}
										className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
									>
										<option value="0">INE</option>
										<option value="1">Pasaporte/Visa</option>
										<option value="2">Curp</option>
										<option value="3">Cartilla Militar</option>
									</select>
								</div>
								<div className="tw-flex tw-flex-col tw-space-y-1">
									<label className="tw-text-sm tw-font-semibold">ID:</label>
									<input
										type="text"
										name="numIdEddit"
										value={this.state.pNumId}
										onChange={e => this.setState(prev => ({ ...prev, pNumId: e.target.value }))}
										className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
										placeholder="Número ID"
										maxLength="24"
									/>
								</div>
							</div>

							{/* Dirección */}
							<div className="tw-flex tw-flex-col tw-space-y-1">
								<label className="tw-text-sm tw-font-semibold">Dirección:</label>
								<input
									type="text"
									name="address"
									value={this.state.pDireccion}
									onChange={e => this.setState(prev => ({ ...prev, pDireccion: e.target.value }))}
									className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
									placeholder="Dirección de contacto"
									maxLength="150"
								/>
							</div>
						</div>

					</div>

					<div className="tw-flex tw-flex-col tw-space-y-2 tw-w-full">
						{/* Municipio y Ciudad */}
						<div className="tw-grid tw-grid-cols-2 tw-gap-2">
							<div className="tw-flex tw-flex-col tw-space-y-1">
								<label className="tw-text-sm tw-font-semibold">Municipio:</label>
								<input
									type="text"
									name="municipality"
									value={this.state.pMunicipio}
									onChange={e => this.setState(prev => ({ ...prev, pMunicipio: e.target.value }))}
									className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
									placeholder="Municipio"
									maxLength="80"
								/>
							</div>
							<div className="tw-flex tw-flex-col tw-space-y-1">
								<label className="tw-text-sm tw-font-semibold">Ciudad:</label>
								<input
									type="text"
									value={this.state.citye}
									onChange={e => this.setState(prev => ({ ...prev, citye: e.target.value }))}
									className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
									id="citye"
									placeholder="Ciudad"
								/>
							</div>
						</div>

						{/* Código Postal y Estado */}
						<div className="tw-grid tw-grid-cols-2 tw-gap-2">
							<div className="tw-flex tw-flex-col tw-space-y-1">
								<label className="tw-text-sm tw-font-semibold">C.P:</label>
								<input
									type="text"
									value={this.state.pCp}
									onChange={e => this.setState(prev => ({ ...prev, pCp: e.target.value }))}
									name="zip"
									className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
									placeholder="Código postal"
									maxLength="10"
								/>
							</div>
							<div className="tw-flex tw-flex-col tw-space-y-1">
								<label className="tw-text-sm tw-font-semibold">Estado:</label>
								<input
									type="text"
									name="state"
									value={this.state.pEstado}
									onChange={e => this.setState(prev => ({ ...prev, pEstado: e.target.value }))}
									className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
									placeholder="Estado"
									maxLength="24"
								/>
							</div>
						</div>

						{/* País */}
						<div className="tw-flex tw-flex-col tw-space-y-1">
							<label className="tw-text-sm tw-font-semibold">País:</label>
							<input
								type="text"
								value={this.state.pPais}
								onChange={e => this.setState(prev => ({ ...prev, pPais: e.target.value }))}
								name="country"
								className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left"
								placeholder="País"
								maxLength="10"
							/>
						</div>
					</div>

					<div className="tw-flex tw-flex-col tw-space-y-2 tw-w-full">
						{/* Fechas con UnifiedDatePicker (sin InputMask) */}
						<div className="tw-grid tw-grid-cols-2 tw-gap-2">
							<div className="tw-flex tw-flex-col tw-space-y-1">
								<label className="tw-text-sm tw-font-semibold">
									Fecha de compra:<span className="tw-text-red-500">*</span>
								</label>
								<UnifiedDatePicker
									selected={fechaCompraObj}
									onChange={(date) => {
										const formatted = date ? moment(date).format('YYYY-MM-DD') : '';
										this.setState(prev => ({ ...prev, pFechaCompra: formatted }));
									}}
									includeTime={false}
									dateFormat="dd/MM/yyyy"
									placeholderText="DD/MM/YYYY"
									className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left w-full"
									id="fcompra"
								/>
							</div>
							<div className="tw-flex tw-flex-col tw-space-y-1">
								<label className="tw-text-sm tw-font-semibold">Fecha de venta:</label>
								<UnifiedDatePicker
									selected={fechaVentaObj}
									onChange={(date) => {
										const formatted = date ? moment(date).format('YYYY-MM-DD') : '';
										this.setState(prev => ({ ...prev, pFechaVenta: formatted }));
									}}
									includeTime={false}
									dateFormat="dd/MM/yyyy"
									placeholderText="DD/MM/YYYY"
									className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm input-edit-select-sm tw-text-left w-full"
									id="fventaedit"
								/>
							</div>
						</div>

						{/* Comentarios */}
						<div className="tw-flex tw-flex-col tw-space-y-1">
							<label className="tw-text-sm tw-font-semibold">Comentarios:</label>
							<textarea
								name="comentarios"
								id="comentarios_inquilinos"
								value={this.state.comentarios}
								onChange={e => this.setState(prev => ({ ...prev, comentarios: e.target.value }))}
								className="tw-border tw-rounded tw-px-2 tw-py-1 tw-text-sm tw-w-full tw-input-edit-select-sm tw-text-left"
								rows="3"
								maxLength="500"
							/>
						</div>

						{/* Es residente */}
						<div className="tw-flex tw-items-center tw-gap-2">
							<input
								type="checkbox"
								name="esInquilino"
								id="esInquilino"
								disabled
								checked={this.state.es_residente ? true : false}
								className="tw-h-4 tw-w-4"
							/>
							<span className="tw-text-sm tw-font-semibold">Es residente</span>
						</div>

						{/* Nota de campos obligatorios */}
						<div className="tw-flex tw-items-center">
							<p className="tw-text-xs tw-text-gray-600">
								<span className="tw-text-red-500">*</span> Indica un campo obligatorio
							</p>
						</div>
					</div>

				</div>
			</div>
		);
	}

	handleClose() {
		this.setState({
			showModal: false,
		});
	}
}

export default PropietarioEditarModal;